module.exports = __webpack_public_path__ + "55bdb5c8c704c1dbcd9b35064f6a8239.pdf";